import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs, pages} from '@modules/constants-enumerate';
import {ApiService, apiRequestInstance} from '@modules/api-service';
import {routerInstance} from '@aofl/router';
import {i18nMixin} from '@aofl/i18n-mixin';

/**
 * @summary RoleToggle
 * @extends {mapStatePropertiesMixin(AoflElement)}
 */
@customElement('profile-toggle')
class ProfileToggle extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of RoleToggle.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static is ='profile-toggle';

  @property({type: String})
  ['item-class'] = '';

  @property({type: Array, mapState: `${sdoNs.SESSION}.$orgs`, store: storeInstance})
  orgs = {};

  @property({type: Object, mapState: `${sdoNs.SESSION}.current_profile`, store: storeInstance})
  currentProfile = {};

  @property({type: Boolean, mapState: `${sdoNs.SESSION}.$showSwitcher`, store: storeInstance})
  showSwitcher = false;

  async switchProfile(e, rootId) {
    try {
      apiRequestInstance.purgeCache();
      const data = await ApiService.userValidate(void 0, rootId);
      storeInstance.purge();
      storeInstance.commit({
        namespace: sdoNs.SESSION,
        mutationId: 'setData',
        payload: {
          ...data.user_info,
          group_info: data.group_info,
          loggedIn: true,
          roles: data.roles,
          settings: data.settings,
          current_role: data.current_role,
          productActivations: data.product_activations,
          products: data.products,
          languages: data.languages,
          profiles: data.user_profiles,
        }
      });
    } catch (e) {}

    storeInstance.commit({
      namespace: sdoNs.LAYOUT,
      mutationId: 'setShowMenu',
      payload: true
    });
    routerInstance.navigate(pages.DASHBOARD, {forceReload: true});
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export default ProfileToggle;
